import { render, staticRenderFns } from "./tawkSupervisor.vue?vue&type=template&id=72d281c7&scoped=true"
import script from "./tawkSupervisor.vue?vue&type=script&lang=js"
export * from "./tawkSupervisor.vue?vue&type=script&lang=js"
import style0 from "./tawkSupervisor.vue?vue&type=style&index=0&id=72d281c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d281c7",
  null
  
)

export default component.exports